import { XMarkIcon } from '@heroicons/react/24/outline';
import Typography from 'components/gruenland/atoms/typography';
import Modal from 'components/gruenland/organisms/modal';
import { useFormat } from 'helpers/hooks/useFormat';
import SaveOrCancel from '../../account-atoms/save-or-cancel';

type DeleteModalProps = {
  modalIsOpen: boolean;
  loading: boolean;
  closeModal: () => void;
  handleDelete: () => void;
};

const DeleteModal: React.FC<DeleteModalProps> = ({ modalIsOpen, loading, closeModal, handleDelete }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <Modal
      shouldCloseOnOverlayClick
      isOpen={modalIsOpen}
      style={{ content: { width: 400, height: 280, overflow: 'hidden', background: 'white' } }}
      contentLabel={formatMessage({ id: 'common.quickView', defaultMessage: 'Anteprima' })}
      onRequestClose={closeModal}
    >
      <>
        <XMarkIcon
          className="absolute right-[15px] top-[15px] size-6 hover:cursor-pointer"
          strokeWidth={1}
          color="#494949"
          onClick={closeModal}
        />

        <div className="m-auto grid h-full place-content-center gap-6">
          <Typography as="h3" className="text-center text-[20px] font-medium text-primary-black">
            {formatMessage({ id: 'address.delete', defaultMessage: 'Elimina indirizzo' })}
          </Typography>
          <Typography as="p" className="text-center text-secondary-black">
            {formatMessage({
              id: 'feedback.warningNoUndo',
              defaultMessage: 'Questa azione non può essere annullata.',
            })}
          </Typography>

          <SaveOrCancel
            className="justify-between"
            loading={loading}
            onCancel={closeModal}
            variant="delete"
            onSave={handleDelete}
          />
        </div>
      </>
    </Modal>
  );
};

export default DeleteModal;
